import { DateTime, Info } from "luxon";
var timezone = process.env.REACT_APP_TIMEZONE || "UTC";
export var getToday = function () { return DateTime.now().setZone(timezone).startOf("day"); };
var splitPartialDate = function (partialDate) {
    return partialDate.split("-").map(function (x) { return parseInt(x); });
};
var parsePartialDate = function (partialDate) {
    var _a = splitPartialDate(partialDate), year = _a[0], month = _a[1], day = _a[2];
    return DateTime.fromObject({
        year: year,
        month: month || 1,
        day: day || 1,
    }, { zone: timezone }).startOf("day");
};
export var isBirthday = function (dateOfBirth) {
    var _a = splitPartialDate(dateOfBirth), month = _a[1], day = _a[2];
    if (month === undefined || day === undefined)
        return false;
    var today = getToday();
    return today.month === month && today.day === day;
};
export var calculateAge = function (dateOfBirth) {
    var accurate = splitPartialDate(dateOfBirth).length === 3;
    var _a = getToday()
        .diff(parsePartialDate(dateOfBirth), ["years", "months", "days"])
        .toObject(), years = _a.years, months = _a.months, days = _a.days;
    if (years)
        return "".concat(accurate ? "" : "~").concat(years, " year").concat(years === 1 ? "" : "s");
    if (months)
        return "".concat(accurate ? "" : "~").concat(months, " month").concat(months === 1 ? "" : "s");
    var floorDays = Math.floor(days !== null && days !== void 0 ? days : 0);
    return "".concat(accurate ? "" : "~").concat(floorDays, " day").concat(floorDays === 1 ? "" : "s");
};
var getMonthName = function (month) {
    if (month < 1 || month > 12)
        throw new Error("Invalid month");
    return Info.months("long")[month - 1];
};
var getOrdinal = function (number) {
    if (number < 1)
        throw new Error("Invalid number");
    var lastDigit = number % 10;
    var lastTwoDigits = number % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13)
        return "th";
    if (lastDigit === 1)
        return "st";
    if (lastDigit === 2)
        return "nd";
    if (lastDigit === 3)
        return "rd";
    return "th";
};
export var formatDate = function (date, showApproximate) {
    if (showApproximate === void 0) { showApproximate = true; }
    var _a = splitPartialDate(date), year = _a[0], month = _a[1], day = _a[2];
    var formattedMonth = month && getMonthName(month);
    var formattedDay = day && "".concat(day).concat(getOrdinal(day));
    if (day && month && year)
        return "".concat(formattedMonth, " ").concat(formattedDay, ", ").concat(year);
    if (month && year)
        return "".concat(showApproximate ? "~" : "").concat(formattedMonth, ", ").concat(year);
    return "".concat(showApproximate ? "~" : "").concat(year);
};
export var sortPartialDates = function (a, b) {
    var parsedA = typeof a === "string" ? parsePartialDate(a).toMillis() : null;
    var parsedB = typeof b === "string" ? parsePartialDate(b).toMillis() : null;
    if (parsedA === parsedB)
        return 0;
    else if (parsedA === null || (parsedB !== null && parsedB > parsedA))
        return 1;
    else
        return -1;
};
